// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"6dc7fe5b","564":"a604e637","676":"5429398c","798":"7be764e6","857":"6729d69d","932":"c0fbad4a"}[chunkId] + ".chunk.js";
};